import { GameId } from "@portal-frontend-ssr/blast-api";
import { useMemo } from "react";
import dotaBg from "./assets/dota.webp?w=1800&format=webp&imagetools";
import csBg from "./assets/cs.webp?w=1800&format=webp&imagetools";
import rlBg from "./assets/rl.webp?w=1800&format=webp&imagetools";

export const Background = ({ gameId }: { gameId: GameId }) => {
  const src = useMemo(() => {
    switch (gameId) {
      case "dota":
        return dotaBg;
      case "cs":
        return csBg;
      case "rl":
        return rlBg;
      default:
        return null;
    }
  }, [gameId]);

  if (!src) {
    return null;
  }

  return <img src={src} alt={gameId} className="-m-nav absolute left-0 top-0 -z-10 w-full object-cover" />;
};
